import * as React from 'react'
import { ButtonProps, colors, font, Tooltip } from 'plume-ui'
import { LoadableButton } from '../../../atoms/LoadableButton'
import { css } from '@emotion/react'
import { IcomoonIcon } from '../../../atoms/IcomoonIcon'

export const DownloadButton: React.FC<
  {
    isLoading?: boolean
    hasPermission: boolean
    className?: string
  } & ButtonProps
> = (props) => {
  const hoverBgColor = 'rgba(0, 0, 0, 0.04)'
  const loadingBgColor = 'rgba(0, 0, 0, 0.06)'

  const buttonRef = React.useRef<HTMLDivElement | null>(null)
  const buttonLabel = () =>
    props.isLoading
      ? 'お待ち下さい...'
      : props.hasPermission
        ? `Excel形式のファイルをダウンロードできます`
        : `新プランをご契約のユーザー限定の機能です。新プランへの移行は当社担当者までお問い合わせください。`

  return (
    <>
      <Tooltip label={buttonLabel()} className={props.className}>
        <div ref={buttonRef} className="download">
          <LoadableButton
            isLoading={props.isLoading}
            disabled={!props.hasPermission}
            spinnerColor={colors.gray70}
            size="small"
            css={css`
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              gap: 4px;
              width: 72px;
              height: 40px;
              padding: 4px 2px !important;
              border: none;
              color: ${colors.textStrong};
              background-color: ${props.isLoading
                ? loadingBgColor
                : 'transparent'};
              font-size: 14px !important;
              font-weight: ${font.weight.normal};
              &:hover {
                color: ${colors.textStrong};
                background-color: ${hoverBgColor};
              }
            `}
            {...props}
          >
            <IcomoonIcon
              name="download"
              css={css`
                font-size: 20px;
              `}
            />
            <div
              css={css`
                font-size: 11px;
                line-height: 100%;
                align-items: center;
                text-align: center;
                letter-spacing: 0.02em;
              `}
            >
              ダウンロード
            </div>
          </LoadableButton>
        </div>
      </Tooltip>
    </>
  )
}
